document.addEventListener('DOMContentLoaded', function () {
    var hamburger = document.querySelector('.hamburger-menu');
    var navUl = document.querySelector('.primary-navigation-ul');
    var originalSvg = hamburger.innerHTML;
    var xSvg = '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><line x1="4" y1="4" x2="20" y2="20" stroke="#19244e" stroke-width="2"/><line x1="20" y1="4" x2="4" y2="20" stroke="#19244e" stroke-width="2"/></svg>';

    hamburger.addEventListener('click', function () {
        var isOpen = hamburger.classList.toggle('open');
        if (isOpen) {
            hamburger.innerHTML = xSvg;
            if (navUl) navUl.style.display = 'grid';
        } else {
            hamburger.innerHTML = originalSvg;
            if (navUl) navUl.style.removeProperty('display');
        }
    });

    window.addEventListener('resize', function () {
        var style = window.getComputedStyle(hamburger);
        if (style.display === 'none') {
            hamburger.classList.remove('open');
            hamburger.innerHTML = originalSvg;
            if (navUl) navUl.style.removeProperty('display');
        }
    });
});

if (window.location.hash.startsWith('#comment-')) {
    var sessionKey = 'commentFormDisabled';
    if (!sessionStorage.getItem(sessionKey)) {
        sessionStorage.setItem(sessionKey, '1');
    }
    history.replaceState(null, '', window.location.pathname + window.location.search);
}
if (sessionStorage.getItem('commentFormDisabled')) {
    var respondDiv = document.getElementById('respond');
    if (respondDiv) {
        respondDiv.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(function (btn) {
            btn.disabled = true;
        });
        var fields = [
            respondDiv.querySelector('textarea#comment'),
            respondDiv.querySelector('input#author')?.closest('p')?.style && (respondDiv.querySelector('input#author').closest('p').style.display = 'none'),
            respondDiv.querySelector('input#email')?.closest('p')?.style && (respondDiv.querySelector('input#email').closest('p').style.display = 'none')
        ];
        fields.forEach(function (field) {
            if (field) {
                field.disabled = true;
            }
        });
        var commentField = respondDiv.querySelector('textarea#comment');
        if (commentField) {
            commentField.placeholder = "Thank you for your message. We have received it and will be in contact soon.";
        }
    }
}

console.log("Legacy Theme");